





















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { TermsTab } from "@/shared/types";
import Tab from "@/shared/components/ui/Tab.vue";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import {
  AppBrowserTarget,
  openUrl
} from "@/shared/mobileHelper";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    Tab,
    TabGroup
  }
})
export default class TermsAndConditionsMobile extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  readonly bendTermsAndConditions = "https://user.bendhsa.com/bend_financial_terms_of_service%2020181009.pdf";

  TermsTab = TermsTab;
  activeTab = TermsTab.Bank;

  get hsaTermsLink (): string {
    return this.custodianSettingsStore.hsaTermsUrl ?
        this.custodianSettingsStore.hsaTermsUrl : this.bendTermsAndConditions;
  }

  open (url) {
    openUrl(url, AppBrowserTarget.system);
  }
}
